/**
 * Login
 */
//New Stuff
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

// React
import React, { useState, useEffect, Fragment } from 'react';

// Helmet
import { Helmet } from 'react-helmet';
// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { loginAction, generateOptAction, verifyOtpAction } from './actions';

import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import { makeSelectToken, makeSelectLoading, makeSelectError } from './selectors';

// UI
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  Avatar,
  Grid,
  CircularProgress,
  Paper,
  Typography,
  Box,
  Link,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Alert from '@material-ui/lab/Alert';
import Countdown from 'react-countdown';
import Icon from '@mdi/react';
import {
  mdiEmailOutline,
  mdiKeyOutline,
  mdiPhone,
  mdiEyeOffOutline,
  mdiEyeOutline,
} from '@mdi/js';
// Helper
import { changePhoneNumberFormatTo98, fixNumbers, formaterPhoneNumber } from '../../utils/helpers';

// Type
import { Props, SelectorProps, Payload, PayloadGenerateOpt } from './interfaces';
import loginRepository from 'client-sdk/src/Repository/login-repository';
import handleError from '../../utils/handleError';

// Style
const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
    overflow: 'hidden',
  },
  login: {
    main: "#24388D",
  },
  image: {
    backgroundImage: 'url("/login.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white',
    height: "100%",
    borderRadius: "10px",
    // margin: "10px",
    // backgroundColor:
    //   theme.palette.type === 'light'
    //     ? theme.palette.grey[50]
    //     : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'right bottom ',
    // marginBottom: '-30px',
    // marginRight:'10px',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  item: {
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    fontWeight: 500,
    width: '100%',
    margin: '0 auto',
    '& > *': {
      // margin: theme.spacing(0, 0, 0, 1),
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 400,
    color: '#8a8a8a',
    marginRight: '8px',
    marginTop: '21px',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    marginBottom: "25px",
    width: theme.spacing(29),
    height: theme.spacing(28),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    // margin: theme.spacing(1, 0, 3),
    // padding: theme.spacing(0, 8),
    textAlign: 'center',
    justifyContent: 'center'
  },
  error: {
    width: "329px",
    margin: theme.spacing(2, 0, 0),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    width: "100%",
    height: theme.spacing(5),
  },
  imageContainer: {
    '@media (min-width: 960px)': {
      padding: "40px",
    },
    backgroundColor: "#fff"
  },
  mobileFirstNumber: {
    padding: "0 10px",
    borderLeft: "1px solid #000",
    margin: 0
  },
  errorMsg: {
    color: "red",
    textAlign: "left",
    margin: 0,
    fontSize: "14px"
  }
}));

function Login(props: Props) {
  const [emailAddress, setEmailAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [mode, setMode] = useState('default');
  const [rememberMe] = useState(true);
  const [hide, setHide] = useState(true);
  const [error, setError] = useState(false)

  const [completions, setCompletions] = useState(0);

  const { search } = useLocation();
  const queryValues = queryString.parse(search);

  useEffect(() => {
    if (process.env.REACT_APP_ENVIROMENT == "sandbox") {
      setMode("generateOpt")
    }
    localStorage.removeItem('token');
  }, []);

  useEffect(() => {
    if (queryValues.phoneNum) {
      changeModeLogin('generateOpt');
      setPhoneNumber(queryValues.phoneNum.toString());
    }
  }, []);

  const handleChangeEmailAddress = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEmailAddress(event.target.value);
  };
  const handleChangePhoneNumber = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPhoneNumber(event.target.value);
  };
  const handleChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCode(event.target.value);
  };
  const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (mode === 'default' && emailAddress.length > 0 && password.length > 0) {
      props.loginDispatch({
        emailAddress,
        password,
        rememberMe,
      });
    } else if (mode === 'generateOpt') {
      if (!/^(\+989|09)\d{9}$/g.test(phoneNumber)) {
        setError(true)
        return
      }
      if (process.env.REACT_APP_ENVIROMENT == "sandbox") {
        generateDemoOtp({
          phoneNumber: changePhoneNumberFormatTo98(fixNumbers(`${phoneNumber}`)),
        })
      } else {
        props.generateOptDispatch({
          phoneNumber: fixNumbers(`${phoneNumber}`),
          callback: () => setMode('verifyOpt'),
        });
      }
    } else if (mode === 'verifyOpt') {
      props.verifyOptDispatch({
        code: fixNumbers(`${code}`),
        phoneNumber: changePhoneNumberFormatTo98(fixNumbers(`${phoneNumber}`)),
        rememberMe: true,
      });
    }
  };
  const changeModeLogin = (mode: string) => {
    setMode(mode);
  };

  const generateDemoOtp = async (payload: any) => {
    try {
      const { response } = await loginRepository.generateDemoOpt({ payload })
      setMode('verifyOpt')
    } catch (err) {
      handleError(err)
    }
  }

  const classes = useStyles();
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />

      </Helmet>
      <Grid container component="main" className={classes.root}>
        <Grid
          item
          xs={12}
          md={4}
          component={Paper}
          square
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <div className={classes.paper}>
            <Avatar
              className={classes.avatar}
              src="/login-logo.svg"
              variant="square"
            />
            <Typography component="h1" variant="h6" style={{ marginBottom: "10px", color: '#24388D' }}>
              {'به سامانه هوشمند پردازش سفارشات روناد'}
            </Typography>
            <Typography component="h1" variant="h6" color='login' style={{ marginBottom: "30px", color: '#24388D' }}>
              {'خوش آمدید'}
            </Typography>
            {/* <h4 id="title" className="text-center mb-0">
              {'خدمات روناد به مشتریان'}
            </h4> */}
            {/* <Grid xs={12} spacing={1} className="col-9 mx-auto">
              <span
                style={{
                  border: '1px #d8d8d8 solid',
                  display: 'inline-block',
                  width: '100px',
                }}
              />
              <span
                style={{
                  border: '1px gold solid',
                  display: 'inline-block',
                  width: '150px',
                }}
              />
              <span
                style={{
                  border: '1px #d8d8d8 solid',
                  display: 'inline-block',
                  width: '100px',
                }}
              />
            </Grid> */}
            {phoneNumber && mode === 'verifyOpt' && (
              <Fragment>
                <Typography variant="caption" display="block" gutterBottom>
                  کد تایید به شماره همراه &nbsp;{phoneNumber}&nbsp; ارسال شد
                </Typography>
                <Grid item xs>
                  <span>اصلاح</span>
                  <Button
                    color="secondary"
                    onClick={() => changeModeLogin('generateOpt')}
                  >
                    شماره همراه
                  </Button>
                </Grid>
              </Fragment>
            )}
            <form className={classes.form}>
              {mode === 'default' && (
                <>
                  <div className={classes.item}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="email"
                        // label="ایمیل "
                        placeholder='ایمیل'
                        name="emailAddress"
                        autoFocus
                        value={emailAddress}
                        InputProps={{
                          startAdornment: (
                            <Icon
                              path={mdiEmailOutline}
                              size={1}
                              className={classes.icon}
                            />
                          ),
                        }}
                        onChange={handleChangeEmailAddress}
                        style={{ backgroundColor: 'white' }}
                      />
                    </Grid>
                  </div>
                  <div className={classes.item}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        style={{ backgroundColor: 'white !important' }}
                        margin="normal"
                        fullWidth
                        name="password"
                        placeholder="رمز عبور"
                        type={hide ? 'password' : 'text'}
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={handleChangePassword}
                        InputProps={{
                          startAdornment: (
                            <Icon
                              path={mdiKeyOutline}
                              size={1}
                              className={classes.icon}
                            />
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={() => setHide(!hide)}>
                                <Icon
                                  path={hide ? mdiEyeOffOutline : mdiEyeOutline}
                                  size={1}
                                  className={classes.icon}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />{' '}
                    </Grid>
                  </div>
                </>
              )}
              {mode === 'generateOpt' && (
                <>
                  <div className={classes.item}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        id="phoneNumber"
                        fullWidth
                        placeholder="شماره موبایل"
                        InputProps={{
                          startAdornment: (
                            <Icon path={mdiPhone} size={1} className={classes.icon} />
                          )
                        }}
                        name="phoneNumber"
                        autoFocus
                        value={phoneNumber}
                        onChange={handleChangePhoneNumber}
                      />
                      {error && <p className={classes.errorMsg}>شماره تلفن اشتباه است</p>}
                    </Grid>
                  </div>
                </>
              )}

              {mode === 'verifyOpt' && (
                <>
                  <div className={classes.item}>
                    <Grid item xs={12}>
                      <TextField
                        variant="standard"
                        margin="normal"
                        id="code"
                        placeholder="کد تایید"
                        name="code"
                        InputProps={{
                          startAdornment: (
                            <Icon
                              path={mdiKeyOutline}
                              size={1}
                              className={classes.icon}
                            />
                          ),
                        }}
                        fullWidth
                        autoFocus
                        value={code}
                        onChange={handleChangeCode}
                      />
                    </Grid>
                  </div>
                  {/* <Typography variant="caption" display="block" gutterBottom>
                    شماره موبایل وارد شده:
                    {phoneNumber}
                  </Typography> */}

                  {/* <Countdown
                    date={Date.now() + 120000}
                    key={completions}
                    onComplete={() => setMode('verifyOpt')}
                    renderer={({minutes, seconds, completed}) => {
                      if (completed) {
                        return (
                          <div>
                            <span>
                              {minutes}:{seconds}
                            </span>
                            <Button
                              color="primary"
                              variant="outlined"
                              onClick={e => {
                                setCompletions(completions + 1);
                                props.generateOptDispatch({
                                  phoneNumber: fixNumbers(`${phoneNumber}`),
                                  callback: () => setMode('verifyOpt'),
                                });
                              }}
                            >
                              درخواست مجدد کد
                            </Button>
                          </div>
                        );
                      } else {
                        return (
                          <div>
                            {minutes}:{seconds}
                          </div>
                        );
                      }
                    }}
                  /> */}
                </>
              )}

              {props.error == 'not-for-this' && mode === 'default' ? (
                <Alert
                  variant="filled"
                  severity="error"
                  className={classes.error}
                >
                  ورود ناموفق، لطفا نام‌کاربری و کلمه عبور را بررسی و دوباره
                  امتحان نمایید
                </Alert>
              ) : (
                props.error &&
                mode === 'default' && (
                  <Alert
                    variant="filled"
                    severity="error"
                    className={classes.error}
                  >
                    ورود ناموفق، لطفا نام‌کاربری و کلمه عبور را بررسی و دوباره
                    امتحان نمایید
                  </Alert>
                )
              )}
              {props.error && mode === 'generateOpt' && (
                <Alert
                  variant="filled"
                  severity="error"
                  className={classes.error}
                >
                  شماره موبایل در سیستم ثبت نشده است
                </Alert>
              )}
              {props.error && mode === 'verifyOpt' && (
                <Alert
                  variant="filled"
                  severity="error"
                  className={classes.error}
                >
                  ورود ناموفق، لطفا دوباره امتحان نمایید
                </Alert>
              )}

              {mode === 'default' && (
                <Button
                  type="submit"
                  variant="contained"
                  color="login-primary"
                  style={{ minWidth: '25%', marginTop: '60px', backgroundColor: '#24388D', color: 'white' }}
                  className={classes.submit}
                  onClick={e => onSubmit(e)}
                  disabled={props.loading}
                >
                  {mode === 'default' && 'ورود'}
                  {props.loading && <CircularProgress size={24} />}
                </Button>
              )}
              {mode === 'verifyOpt' && (
                <Button
                  type="submit"
                  variant="contained"
                  color="login-primary"
                  style={{ minWidth: '25%', marginTop: '60px', color: '#24388D' }}
                  className={classes.submit}
                  onClick={e => onSubmit(e)}
                  disabled={props.loading}
                >
                  {mode === 'verifyOpt' && 'ورود'}
                  {props.loading && <CircularProgress size={24} />}
                </Button>
              )}
              {mode === 'generateOpt' && (
                <Button
                  type="submit"
                  variant="contained"
                  color="login-primary"
                  style={{ minWidth: '25%', marginTop: '60px', color: 'white', backgroundColor: '#24388D' }}
                  className={classes.submit}
                  onClick={e => onSubmit(e)}
                  disabled={phoneNumber.length == 0}
                >
                  {mode === 'generateOpt' && 'دریافت کد تایید'}

                  {props.loading && <CircularProgress size={24} />}
                </Button>
              )}
              {mode === 'verifyOpt' && (
                <Countdown
                  date={Date.now() + 120000}
                  key={completions}
                  onComplete={() => setMode('verifyOpt')}
                  renderer={({ minutes, seconds, completed }) => {
                    if (completed) {
                      return (
                        <div>
                          <span>
                            {minutes}:{seconds}
                          </span>
                          <Button
                            style={{ color: 'white', backgroundColor: '#24388D' }}
                            variant="outlined"
                            onClick={e => {
                              setCompletions(completions + 1);
                              props.generateOptDispatch({
                                phoneNumber: fixNumbers(`${phoneNumber}`),
                                callback: () => setMode('verifyOpt'),
                              });
                            }}
                          >
                            درخواست مجدد کد
                          </Button>
                        </div>
                      );
                    } else {
                      return (
                        <div>
                          {minutes}:{seconds}
                        </div>
                      );
                    }
                  }}
                />
              )}
              {/* <Grid
                container
                xs={12}
                style={{ marginTop: '30px' }}
                justifyContent="space-around"
              >
                <Grid item xs={5}>
                  <Divider
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      marginTop: '10px',
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{ textAlign: 'center', lineHeight: '1.5' }}
                >
                  {'یا'}
                </Grid>
                <Grid item xs={5}>
                  <Divider
                    style={{
                      width: '100%',
                      textAlign: 'right',
                      marginTop: '10px',
                    }}
                  />
                </Grid>
              </Grid> */}
              {/* <Grid container style={{ textAlign: 'center', marginTop: '15px' }}>
                {mode === 'default' ? (
                  <Grid item xs>
                    <span>ورود با</span>
                    <Button
                      color="secondary"
                      onClick={() => changeModeLogin('generateOpt')}
                    >
                      شماره موبایل
                    </Button>
                  </Grid>
                ) : (
                  <Grid item xs>
                    <span>ورود با</span>
                    <Button
                      color="secondary"
                      onClick={() => changeModeLogin('default')}
                    >
                      ایمیل
                    </Button>
                  </Grid>
                )}
              </Grid> */}
            </form>
            {/* <Box mt={1} style={{ marginBottom: '100px' }}>
              <Typography variant="body1" color="textSecondary" align="center">
                {' پشتیبانی: '}
                <Link href="tel:02191070761">91070761 - 021</Link>{' '}
              </Typography>
            </Box> */}
          </div>
        </Grid>
        <Grid item md={8} xs={false} className={classes.imageContainer}>
          <Grid item xs={false} className={classes.image} />
        </Grid>
      </Grid>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  token: makeSelectToken(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    loginDispatch: (payload: Payload) => dispatch(loginAction(payload)),
    generateOptDispatch: (payload: PayloadGenerateOpt) =>
      dispatch(generateOptAction(payload)),
    verifyOptDispatch: (payload: {
      code: string;
      phoneNumber: string;
      rememberMe: boolean;
    }) => dispatch(verifyOtpAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Login);
